import React, { useState, useEffect } from 'react';
import Categories from './categories';
import LureDisplay from './luredisplay';
import Wizard from './wizard';
import { createInitialModel } from '../helpers/modelhelper';
import { mergeImageArrays, applyDisplayOrder, assignAttributeIds } from '../helpers/imagecategoryhelper';
import { simplifyCategoryName } from '../helpers/modelhelper';
import { startWizard, categoryConstants, categories, categoryLimits } from '../constants/categoryconstants';
import '../lurebuilder.css';

const LureBuilder = () => {
    const [images, setImages] = useState(mergeImageArrays(window.lurebuilderImages));
    const [clickedCategory, setClickedCategory] = useState(categoryConstants.BASECOLOR);
    const [selectedImage, setSelectedImage] = useState();
    const [categoryIsSelected, setCategoryIsSelected] = useState(0);
    const [imageIsSelected, setImageIsSelected] = useState();
    const [currentView, setCurrentView] = useState(startWizard);
    const [selImg, setSelImg] = useState(assignAttributeIds(createInitialModel(categories, mergeImageArrays(window.lurebuilderImages)), window.lurebuilderImages));
    const [productId] = useState(window.productId);

    useEffect(() => {
        setImgToUrl();
    }, [selImg]);

    /**
     * User clicks an image in the list of images in the wizard to display it on lure display
     * @param {*} clickedImage 
     */
    const handleImageClick = clickedImage => {
        let index = clickedImage.target.getAttribute('index');
        let category = clickedImage.target.getAttribute('category');
        let active = clickedImage.target.getAttribute('active');
        setImageIsSelected(index);
        insertSelectedImage(category, index, !tryParseInt(index), clickedImage.target.src, clickedImage.target.getAttribute('imageid'), clickedImage.target.getAttribute('active'));
        setUrl(category, index);
        setSelectedImage({
            active,
            imageUrl: clickedImage.target.src,
            title: clickedImage.target.alt,
            category
        });
    }

    /**
     * Sets the url query params to whatever has been clicked by the user
     * @param {} category 
     * @param {*} index 
     */
    const setUrl = (category, index, del = false) => {
        let url = new URL(document.location);
        let params = new URLSearchParams(url.search.slice(1));
        if (!del) {
            params.set(encodeURIComponent(simplifyCategoryName(category).toLowerCase()), index);
            
        } else {
            params.delete(encodeURIComponent(simplifyCategoryName(category).toLowerCase()));
        }
        
        window.history.replaceState({}, '', `${location.pathname}?${params}`);
    }

    const resetUrl = () => {
        window.history.replaceState({}, '', `${location.pathname}`);
    }

    const setImgToUrl = (imgs) => {
        let url = new URL(document.location);
        let params = new URLSearchParams(url.search.slice(1));
        params.set('imgs', getAllImgIds(imgs));
        window.history.replaceState({}, '', `${location.pathname}?${params}`);
    }

    const getAllImgIds = () => {
        let urls = selImg.map(u => {
            if (u.subCategories.length > 0) {
                return u.subCategories.filter(sub => {
                    return sub.imageUrl !== null;
                });
            } else {
                return [u];
            }
        });
        let onlyvalues = urls.filter(url => {
            return url.length > 0;
        });
        let urlStrings = [].concat.apply([], onlyvalues).map(obj => {
            return obj.imageUrl;
        });
        return urlStrings.map(url => {
            return getImgId(url);
        }).join()
    }
    
    const getImgId =  (url) => {
        if (url != null) {
            let filename = url.split('\\').pop().split('/').pop();
            return filename.split('_')[0];
        } else {
            return '';
        }
    }

    const boolParse = value => {
        return value == "true";
    }

    /**
     * Insert selected image index for current category into state.
     * This is for keeping track of which image is selected in every separate category
     * @param {*} category 
     * @param {*} index 
     */
    const insertSelectedImage = (category, index, isSubCategory, imageUrl, imageId, active) => {
        const images = selImg ? selImg : categories;

        if (!isSubCategory) {
            setSelImg(images.map(cat => {
                if (cat.category === category) {
                    return {
                        ...cat,
                        id: cat.id,
                        active: boolParse(active),
                        selectedImage: parseInt(index),
                        category,
                        imageUrl,
                        imageId: parseInt(imageId),
                        subCategories: []
                    }
                } else {
                    return {
                        ...cat
                    };
                }
            }));
        } else {
            setSelImg(images.map(cat => {
                return {
                    ...cat,
                    subCategories: cat.subCategories.map(sc => {
                        if (sc.category === category) {
                            return {
                                ...sc,
                                id: sc.id,
                                active: boolParse(active),
                                selectedImage: index,
                                imageId: parseInt(imageId),
                                category,
                                imageUrl: imageUrl
                            };
                        } else {
                            return {
                                ...sc
                            };
                        }
                    })
                }
            }));
        }
    }

    /**
     * Steps the wizard view either back or forward depending on user interaction
     * @param {*} isNextStep 
     */
    const handleViewStep = (isNextStep) => {

        // If view should step back
        if (!isNextStep && currentView > categoryLimits.min) {
            handleClick(currentView - 1)
        }
        // If view should step forward
        if (isNextStep && currentView < categoryLimits.max) {
            handleClick(currentView + 1)
        }
        // If view is at max the view should step to add to cart view
        if (isNextStep && currentView === categoryLimits.max) {
            handleClick(categoryLimits.min);
        }
        if(!isNextStep && currentView === categoryLimits.min) {
            handleClick(categoryLimits.max);
        }
        // If view is at addtocart and view should step back to last category
        if (!isNextStep && currentView > categoryLimits.max) {
            handleClick(currentView - 1);
        }
        // If view is at addtocart and view should step back to first step
        if (isNextStep && currentView > categoryLimits.max) {
            handleClick(0);
        }
        if (document.getElementById('lb-img-list-container')) {
            document.getElementById('lb-img-list-container').scrollTo(0, 0);
        }
    }

    function tryParseInt(str) {
        return parseInt(str) == str ? true : false;
    }

    const resetLure = () => {
        resetUrl();
        setImages(mergeImageArrays(window.lurebuilderImages));
        setSelectedImage(null);
        setImageIsSelected(null);
        setClickedCategory(categoryConstants.BASECOLOR);
        setCategoryIsSelected(0);
        setSelImg(assignAttributeIds(categories, window.lurebuilderImages));
        setCurrentView(startWizard);
    }


    const resetCategory = (category) => {
        let newModel = selImg.map(selectedImage => {
            if (selectedImage.category === category) {
                // if is main category return reset object
                if (selectedImage.subCategories.length === 0) {
                    setUrl(category, 0, true);

                    return {
                        ...selectedImage,
                        imageId: null,
                        imageUrl: null,
                        selectedImage: -1,
                    }
                    // else has subcategories change should go in there instead
                } else {
                    return {
                        ...selectedImage,
                        subCategories: selectedImage.subCategories.map(sc => {
                            setUrl(sc.category, 0, true);
                            return {
                                ...sc,
                                imageId: null,
                                imageUrl: null,
                                selectedImage: -1
                            }
                        })
                    };
                }
            } else {
                return selectedImage;
            }
        });
        setSelImg(newModel);
    }

    /**
     * sets which category is to be rendered in the wizard view.
     * Handles both clicking a category and stepping with the next/previous buttons
     * by checking if clickedcategory is int 
     * @param {*} clickedCategory 
     */
    const handleClick = (clickedCategory) => {
        if (document.getElementById('lb-img-list-container')) {
            document.getElementById('lb-img-list-container').scrollTo(0, 0);
        }
        let catIndex;
        if (tryParseInt(clickedCategory)) {
            catIndex = clickedCategory;
            setClickedCategory(categories.find(x => x.id === clickedCategory).category);
        } else {
            catIndex = applyDisplayOrder(images.filter(img => {
                return img.category === categoryConstants.CATEGORIES;
            }), window.categoryOrder).findIndex(cats => {
                return cats.title === clickedCategory;
            });
            setClickedCategory(clickedCategory);
        }
        setCurrentView(catIndex);
        setCategoryIsSelected(catIndex);
    }
    
    return (
        <div className="builder-container row">
            <LureDisplay images={images} newImage={selectedImage} model={selImg} />
            <Categories images={images} handleClick={handleClick} selectedCategory={categoryIsSelected} />
            <Wizard
                category={clickedCategory}
                images={images}
                view={currentView}
                handleImageClick={handleImageClick}
                handleViewStep={handleViewStep}
                selectedImage={imageIsSelected}
                selImg={selImg}
                resetCategory={resetCategory}
                productId={productId}
                completedLureImageId={window.completedLureId}
                completedLureUrlId={window.completedLureUrlId}
                resetLure={resetLure}
            />
        </div>
    );
}

export default LureBuilder;